import CollapsedContainerRow from './CollapsedContainerRow'

export default CollapsedContainerRow
